import { useMemo, useState } from 'react';
import SidebarWrapper, { SidebarProps } from 'react-sidebar';
import styled from 'styled-components';
import { useWindowWidth } from '@react-hook/window-size';
import { Outlet } from 'react-router-dom';
import { Footer } from 'components/layout/Footer';
import { Topbar } from 'components/layout/Topbar';
import { Sidebar } from './Sidebar';

// Extend SidebarProps to include children
interface ExtendedSidebarProps extends SidebarProps {
    children?: React.ReactNode;
}

// Cast SidebarWrapper to accept children
const SidebarWithChildren = SidebarWrapper as React.ComponentType<ExtendedSidebarProps>;

const MainLayout = () => {
    const width = useWindowWidth();
    const [open, setOpen] = useState(false);
    const isDesktop = width > 800;
    const [docked, setDocked] = useState(isDesktop);

    const toggleOpen = () => {
        if (isDesktop) {
            setDocked(!docked);
        } else {
            setDocked(false);
            setOpen(!open);
        }
    };

    useMemo(() => {
        setDocked(isDesktop);
        setOpen(false);
    }, [isDesktop]);

    return (
        <SidebarWithChildren sidebar={<Sidebar />} docked={docked} open={open} onSetOpen={setOpen} sidebarClassName="sidebar" overlayClassName="overlay">
            <Topbar onMenuClick={toggleOpen} />
            <Content>
                <Outlet />
            </Content>
            <Footer />
        </SidebarWithChildren>
    );
};

export default MainLayout;

const Content = styled.div`
    background-color: ${(props) => props.theme.mainBackground};
    padding: 16px;
    min-height: calc(100vh - 100px);
`;
